module.exports = __webpack_public_path__ + "static/media/1010659.84852635.jpg";